module.exports = __webpack_public_path__ + "static/media/bttn_radio_yellow.ddcb1e67.svg";